import React from 'react';
import { useNavigate } from 'react-router-dom';
import CadastroCliente from './CadastroCliente';
import { cadastrarCliente } from '../services/api';

const NovoCliente = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    try {
      await cadastrarCliente(data, token);
      navigate('/clientes'); 
    } catch (err) {
      const data = err?.response?.data;

      if (typeof data === 'string') {
        alert(data);
        return;
      }

      const message =
        data?.message ||
        (data?.errors && Object.values(data.errors).flat().join('\n')) ||
        err.message ||
        'Erro ao salvar cliente.';

      alert(message);
      console.error(err);
    }
  };

  return (
    <CadastroCliente onSubmit={handleSubmit} token={token} />
  );
};

export default NovoCliente;
